import { Button, Modal, notification } from 'antd'
import React, { useState } from 'react'

import { renderDate } from '../../../../components/tables/table-column-renderers'
import { httpClient } from '../../../../util/http-client'
import { messages } from '../../messages'
import { BespokeRating } from '../models'

interface DeleteBespokeRatingModalProps {
  domain: string
  bespokeRating: BespokeRating
  isVisible: boolean
  onClose: () => void
  onSuccess: () => void
}

export const DeleteBespokeRatingModal = ({
  domain,
  bespokeRating,
  isVisible,
  onClose,
  onSuccess,
}: DeleteBespokeRatingModalProps) => {
  const [isDeleting, setIsDeleting] = useState(false)

  const onDelete = async (rfqEmailId: number) => {
    setIsDeleting(true)

    try {
      const url = `/banking-groups/${bespokeRating?.bankingGroupId}/compliance-rules/${bespokeRating?.id}`
      await httpClient(url, { method: 'DELETE', domain })
      onSuccess()

      notification.success({ message: messages.common.success, description: messages.deleteRfqEmail.success })
    } catch (error) {
      notification.error({
        message: messages.common.error,
        description: error.error_message || messages.deleteRfqEmail.error,
      })
    } finally {
      setIsDeleting(false)
    }
  }

  return (
    <Modal
      title="Delete bespoke Rating Email"
      onCancel={onClose}
      open={isVisible}
      className="delete-modal-message"
      footer={[
        <div className="footer">
          <Button key="back" onClick={onClose}>
            Cancel
          </Button>
          <Button
            onClick={() => onDelete(bespokeRating?.id)}
            disabled={isDeleting}
            loading={isDeleting}
            type="primary"
            danger
          >
            Delete
          </Button>
        </div>,
      ]}
    >
      {buildDeleteMessage(bespokeRating)}
    </Modal>
  )
}

const buildDeleteMessage = (bespokeRating: BespokeRating) =>
  `Are you sure that you want to delete this RFQ email?\n
  - ID: ${bespokeRating?.id}\n
  - Banking Group: ${bespokeRating?.bankingGroupId} - ${bespokeRating?.name}\n
  - Start Date: ${renderDate(new Date(bespokeRating?.startDate))}\n
  It cannot be reverted`
